export default __webpack_public_path__ + "static/media/miners.856b84a6.png";